import * as React from 'react';

import { ErrorPage as ErrorPageComponent } from '@/components/Elements/ErrorPage';

export const ErrorPage = () => {
  return <ErrorPageComponent />;
};
